import React, { FC, Fragment } from 'react';
import { useTranslate } from 'react-admin';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { ReceiptIcon as PartnersIcon } from '~/img';
import { H3, TextField } from '~/components';
import { Transaction } from '~/types';
import { useGetServiceQuery } from '~/hooks/paymentServices';
import { Target } from '~/types/profile';

const useStyles = makeStyles((theme) => ({
  innerContent: {
    paddingLeft: theme.spacing(4),
  },
}));

const label = (key: string): string => `components.TransactionView.${key}`;

interface TransactionServiceViewProps {
  transaction: Transaction;
  target: Target;
}

const TransactionServiceView: FC<TransactionServiceViewProps> = (props) => {
  const { transaction, target } = props;
  const service = transaction.details.service!;
  const parameters = service.parameters || {};

  const classes = useStyles();

  const translate = useTranslate();
  const t = (key: string): string => translate(label(key));

  const { data: serviceSchema } = useGetServiceQuery(service.id!, true);

  const parameterFields = Object.keys(parameters).map((key) => {
    const value = typeof parameters[key] === 'object' ? parameters[key].value : parameters[key];
    const name = serviceSchema?.parameters[key]?.name || key;
    return (
      <Grid key={key} item xs={12}>
        <TextField label={name}>{value}</TextField>
      </Grid>
    );
  });

  return (
    <Fragment>
      <H3 icon={<PartnersIcon />}>{t('service')}</H3>
      <Grid item container spacing={2} className={classes.innerContent}>
        <Grid item xs={12}>
          <TextField label={t('serviceName')} textWrap>
            {service.name}
          </TextField>
        </Grid>
        {target !== 'partners' && (
          <Grid item xs={12}>
            <TextField label={t('partnerId')} textWrap>
              {service.partnerId}
            </TextField>
          </Grid>
        )}
        {parameterFields}
      </Grid>
    </Fragment>
  );
};

export default TransactionServiceView;
